// const formatNumberID = (val) => {
//   if (val >= 1_000_000_000_000) {
//     // 1 Triliun
//     return (val / 1_000_000_000_000).toFixed(1).replace(/\.0$/, "") + "T";
//   } else if (val >= 1_000_000_000) {
//     // 1 Miliar
//     return (val / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "M";
//   } else if (val >= 1_000_000) {
//     // 1 Juta
//     return (val / 1_000_000).toFixed(1).replace(/\.0$/, "") + "Jt";
//   } else if (val >= 1_000) {
//     // 1 Ribu
//     return (val / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
//   } else {
//     return Math.round(val).toString(); // below 1k, show as is
//   }
// };

// export { formatNumberID };

const formatNumberID = (val) => {
  if (isNaN(val)) return "0";
  return Math.round(val)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export { formatNumberID };
